var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 items-top customContainer justify-flex-start w-auto items-center pr-6",
      class: _vm.parentInputClass,
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
          [
            _c("FormGroup", {
              attrs: {
                type: "search",
                placeholder: "Search for name, or job title",
                isIcon: true,
                iconStyle: "customIcon",
                title: "",
                inputClass: "customFormInput NotesWidth",
                debounceTime: 500,
              },
              model: {
                value: _vm.nameJobTitle,
                callback: function ($$v) {
                  _vm.nameJobTitle = $$v
                },
                expression: "nameJobTitle",
              },
            }),
            _c(
              "FormGroup",
              [
                _c("FormDatepicker", {
                  attrs: {
                    isCalenderIcon: true,
                    iconStyle: "customIcon",
                    inputClass: "h-9 w-40",
                    calendarClass:
                      "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                    customInputClass: "rounded-lg text-storm-gray text-sm h-1",
                    label: "",
                    placeholder: "Select date",
                  },
                  model: {
                    value: _vm.createdAt,
                    callback: function ($$v) {
                      _vm.createdAt = $$v
                    },
                    expression: "createdAt",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("UiButtonMessage", {
          attrs: {
            buttonClass: "customAdd",
            buttonText: "Reset",
            textClass: "customText customOnlyText",
          },
          on: { click: _vm.handleReset },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }